import customAxios from './axiosConfig'

const BrandService = {
  logo (brand_id) {
    const api_url = window.Urls['brand_logo_details'](brand_id)
    return customAxios.get(api_url, { useCache: true })
  },
  list (params) {
    const api_url = window.Urls['brand_list']()
    return customAxios.get(api_url, { params: params })
  },
  retrieve (brand_id) {
    const api_url = window.Urls['brand-detail'](brand_id)
    return customAxios.get(api_url)
  },
  getMainBrand(params){
    const api_url = window.Urls['brand-main-brand']()
    return customAxios.get(api_url, { params: params })
  },
  create (data) {
    const api_url = window.Urls['brand-list']()
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())
    return customAxios.post(api_url, getFormData(data), headers)
  },
  update (brand_id, data) {
    const api_url = window.Urls['brand-detail'](brand_id)
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const getFormData = object => Object.keys(object).reduce((formData, key) => {
      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]))
      } else {
        formData.append(key, object[key])
      }
      return formData
    }, new FormData())
    return customAxios.put(api_url, getFormData(data), headers)
  },
  destroy (pk) {
    const api_url = window.Urls['brand-detail'](pk)
    return customAxios.delete(api_url)
  },
  uploadLogo (pk, payload) {
    const formData = new FormData()
    formData.append('brand_logo', payload.file)
    // if (payload.logo_id) {
    //   formData.append('brand_logo', payload.logo_id)
    // }
    var url = window.Urls['brand-detail'](pk)
    var headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    return customAxios.patch(url, formData, headers);
  },
  deleteLogo (pk) {
    var url = window.Urls['brand_delete_logo'](pk)
    return customAxios.delete(url);
  },
  archive(pk) {
    const api_url = window.Urls['brand_archive'](pk)
    return customAxios.put(api_url)
  },
  makeDefault(pk) {
    const api_url = window.Urls['brand_make_default'](pk)
    return customAxios.put(api_url)
  }
}

export default BrandService